<template>

  <b-modal
      id="notice-modal"
      modal-class='form notice-modal'
      modal-footer="hide"
      scrollable
      centered
      :title="'Notice'"
  >

    <div class="form form__export">
      <img src="/img/notice.png">
    </div>

    <template v-slot:modal-footer>
      <div></div>
    </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "NoticeModal",
  components: {
  },
  data () {
    return {
    }
  },

  computed: {
    ...mapGetters([]),
  },
  methods: {
    closeMe() {
      this.cleanMe();
      this.$root.$emit('bv::hide::modal', 'notice-modal');
    },
  }
}
</script>

